<template>
  <v-row>
    <v-col cols="12" class="pa-5">
      <!--div>
        <div class="subtitle-1 mb-3 font-weight-bold">발신자 이메일</div>
        <div class="d-flex justify-space-between">
          <v-text-field v-model="email_sender" outlined dense readonly="readonly" background-color="grey lighten-3"
            placeholder="우측 ‘이메일 설정’ 버튼을 클릭하여 이메일 정보를 등록해 주세요."></v-text-field>
          <v-btn class="info ml-2" @click="openEmailSenderModal">이메일 설정</v-btn>
        </div>
      </div-->
      <div>
        <div class="subtitle-1 mb-2 font-weight-bold">메일 제목</div>
        <v-text-field v-model="email_title" outlined dense placeholder="메일 제목을 입력해 주세요."></v-text-field>
      </div>
      <div>
        <div class="d-flex justify-space-between align-center mb-0">
          <div class="mb-2 subtitle-1 font-weight-bold">메일 내용</div>
          <div v-if="!is_manual">
            <v-btn small outlined color="grey lighten-3" class="grey lighten-3 text--darken-3 mr-2" @click="initContentText"
              >기본 메시지 적용</v-btn
            >
            <v-menu offset-y transition="slide-y-transition">
              <template v-slot:activator="{ on }">
                <v-btn small outlined color="grey lighten-3" class="grey lighten-3 text--darken-3" v-on="on">#변수 추가</v-btn>
              </template>
              <v-list>
                <v-list-item v-for="(item, index) in add_text_list" :key="index" link>
                  <v-list-item-title @click="addContentValue(item.text)">{{ item.desc }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </div>
        <div id="summernote"></div>
      </div>
    </v-col>
    <v-col cols="12" class="d-flex justify-space-between pl-4 pb-0">
      <v-btn width="49%" dark @click="closeModal">닫기</v-btn>
      <v-btn width="49%" class="info" @click="saveSettings">저장</v-btn>
    </v-col>
  </v-row>
</template>

<style>
.ql-toolbar.ql-snow {
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
}

.container {
  width: 100% !important;
  padding: 12px !important;
  margin-right: auto;
  margin-left: auto;
}

body {
  font-size: 16px !important;
}

legend {
  width: 0px !important;
}

hr {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}

label {
  font-weight: normal !important;
  margin-bottom: 0 !important;
}

.col-sm-1,
.col-sm-10,
.col-sm-11,
.col-sm-12,
.col-sm-2,
.col-sm-3,
.col-sm-4,
.col-sm-5,
.col-sm-6,
.col-sm-7,
.col-sm-8,
.col-sm-9 {
  float: unset !important;
}

table .row {
  margin-left: unset !important;
  margin-right: unset !important;
}

.modal-content {
  margin: 0px;
  width: unset;
  height: unset;
}

.v-application ul.note-dropdown-menu {
  padding-left: unset !important;
}

.modal-backdrop {
  z-index: unset !important;
}

.note-modal .modal-dialog {
  margin-top: 120px !important;
}

.note-modal .modal-content {
  padding-top: 10px !important;
  padding-bottom: 0px !important;
}
</style>

<!-- include libraries(jQuery, bootstrap) -->
<script src="https://code.jquery.com/jquery-3.5.1.min.js"></script>
<script src="https://stackpath.bootstrapcdn.com/bootstrap/3.4.1/js/bootstrap.min.js"></script>
<!-- include summernote css/js -->
<!--link href="https://stackpath.bootstrapcdn.com/bootstrap/3.4.1/css/bootstrap.min.css" rel="stylesheet">
<link href="https://cdn.jsdelivr.net/npm/summernote@0.9.0/dist/summernote.min.css" rel="stylesheet"-->
<script src="https://cdn.jsdelivr.net/npm/summernote@0.9.0/dist/summernote.min.js"></script>
<script src="https://cdnjs.cloudflare.com/ajax/libs/summernote/0.8.18/lang/summernote-ko-KR.min.js"></script>
<script>
//import EmailSetting from "@/components/authservice/message/modal/EmailSetting.vue";
import M from "@/libs/mapping.js";
import CommonMixin from "@/mixins/CommonMixin.js";
export default {
  props: {
    msg_type: {
      type: String,
      required: true,
    },
    is_manual: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      editor: null,
      is_editor_load: false,
      email_title: "",
      email_sender: null,
      email_content: "",
      add_text_list: null,
      sample_content_data: this.getSampleData(),
    };
  },
  mixins: [CommonMixin],
  mounted: function() {
    this.resetEmailDetailSetting();
    const jquery_script = document.createElement("script");
    jquery_script.src = "https://code.jquery.com/jquery-3.5.1.min.js";
    jquery_script.onload = () => {
      const boot_js = document.createElement("script");
      boot_js.src = "https://stackpath.bootstrapcdn.com/bootstrap/3.4.1/js/bootstrap.min.js";
      document.head.appendChild(boot_js);

      const summer_script = document.createElement("script");
      summer_script.src = "https://cdn.jsdelivr.net/npm/summernote@0.9.0/dist/summernote.min.js";
      summer_script.onload = () => {
        const imagePlugin = document.createElement("script");
        //imagePlugin.src = "/authservice/etc/userfront/registration/custom_summernote.js";
        imagePlugin.src = "/authservice/etc/userfront/registration/summernote-image-link.js";
        document.head.appendChild(imagePlugin);
        const langScript = document.createElement("script");
        //langScript.src = "https://cdnjs.cloudflare.com/ajax/libs/summernote/0.8.18/lang/summernote-ko-KR.min.js";
        langScript.src = "/authservice/etc/userfront/registration/summernote-ko-KR.js";
        document.head.appendChild(langScript);
        langScript.onload = () => {
          this.loadEditor();

          //this.is_editor_load = true;
          //this.setEditerText(this.email_content);
          //this.changeDialogText();
        };
      };

      document.head.appendChild(summer_script);
      /*
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
        const linkDialog = document.querySelector('.link-dialog');
        if (linkDialog && linkDialog.style.display !== 'none') {
          //parent.changeDialogText();
          console.log("test link dialog open");
        }
          }
        });
      });

      observer.observe(document.body, {
        attributes: true,
        subtree: true,
        attributeFilter: ['style'],
      });
      */
    };

    document.head.appendChild(jquery_script);

    const boot_link = document.createElement("link");
    boot_link.rel = "stylesheet";
    boot_link.href = "https://stackpath.bootstrapcdn.com/bootstrap/3.4.1/css/bootstrap.min.css";
    //boot_link.href = "/assets/authservice/css/bootstrap_custom.css";
    document.head.appendChild(boot_link);
    const editor_link = document.createElement("link");
    editor_link.rel = "stylesheet";
    editor_link.href = "https://cdn.jsdelivr.net/npm/summernote@0.9.0/dist/summernote.min.css";
    document.head.appendChild(editor_link);

    const body = document.querySelector("html");
    body.style.fontSize = "16px";
  },
  components: {
    //EmailSetting,
  },
  watch: {
    msg_type: function(newVal, oldVal) {
      this.resetEmailDetailSetting();
    },
    email_content: function(newVal, oldVal) {
      this.setEditerText(newVal);
    },
  },
  methods: {
    loadEditor: function() {
      const parent = this;
      const hints = this.add_text_list.map((item) => item.text);
      $("#summernote").summernote({
        disableDragAndDrop: true,
        height: 300,
        //lang: 'en-US',
        lang: "ko-KR",
        toolbar: [
          /*['style', ['style']],*/
          ["fontsize", ["fontsize"]],
          ["style", ["bold", "italic", "underline", "strikethrough", "clear"]],
          ["fontname", ["fontname"]],
          ["color", ["color"]],
          ["para", ["ul", "ol", "paragraph"]],
          ["height", ["height"]],
          ["insert", ["link", "picture"]],
          //['view',['undo','redo']],
          /* ['view', ['fullscreen', 'codeview', 'help']]*/
        ],
        fontSizes: ["8", "9", "10", "11", "12", "14", "16", "18", "20", "22", "24", "28", "30", "36", "50", "72"],
        //*
        popover: {
          image: [
            ["custom", ["imageLink", "imageUnLink"]],
            //['imagesize', ['imageSize100', 'imageSize50', 'imageSize25']],
            //['resize', ['imageResizeFull', 'imageResizeHalf', 'imageResizeQuarter', 'imageResizeNone']],
            ["resize", ["resizeFull", "resizeHalf", "resizeQuarter", "resizeNone"]],
            ["float", ["floatLeft", "floatRight", "floatNone"]],
            ["remove", ["removeMedia"]],
            ["link", ["linkImage", "unlinkImage"]],
          ],
        },
        //*/
        hint: {
          mentions: hints,
          match: /\B#{(\w*)$/,
          search: function(keyword, callback) {
            callback(
              $.grep(this.mentions, function(item) {
                return item.indexOf("#{" + keyword) === 0;
              }),
            );
          },
          content: function(item) {
            return item;
          },
        },
        callbacks: {
          onImageUpload: function(files) {
            /*
              const selectedNode = $('#summernote').summernote('createRange').sc;
              console.log(selectedNode);
              // upload image to server and create imgNode...
              */
            // console.log("image upload check");
            const reader = new FileReader();
            reader.onload = function(e) {
              const binary = e.target.result;
              parent.uploadImage(binary, files[0]);
            };
            reader.readAsDataURL(files[0]);
            //$summernote.summernote('insertNode', imgNode);
          },
          onInit: function() {
            // console.log("init summernote");
            parent.is_editor_load = true;
            parent.setEditerText(parent.email_content);
            parent.changeDialogText();
          },
        },
      });
    },
    uploadImage: async function(binaryData) {
      try {
        const res = await M.api(M.entry("/post/image"), { image: binaryData });
        if (res) {
          const imgNode = document.createElement("img");
          imgNode.src = res.image;
          $("#summernote").summernote("insertNode", imgNode);
        }
      } catch (err) {
        console.log("upload image", err);
      }
    },
    changeDialogText: function() {
      const link_dialog = document.querySelector(".link-dialog");
      if (link_dialog) {
        link_dialog.querySelector(".modal-title").innerText = "링크 연결";
        link_dialog.querySelector(".note-form-label:first-child").innerText = "링크 연결 텍스트";
        document.querySelector(".link-dialog .note-link-url").previousSibling.innerText = "링크 입력";
        document.querySelector(".link-dialog .note-link-url").placeholder = "연결 할 URL을 입력해주세요.";
        document.querySelector(".link-dialog .sn-checkbox-open-in-new-window label").firstChild.nextSibling.textContent = "새 창 연결";
        link_dialog.querySelector(".note-link-btn").value = "적용";
      }
      //const image_dialog = document.querySelector('.note-image-dialog');
      const image_dialog = $('[aria-label="이미지 추가"]');
      if (image_dialog) {
        image_dialog.find(".modal-title").text("이미지 추가");
        image_dialog.find(".note-form-group:first-child .note-form-label").text("이미지 파일 추가");
        image_dialog.find(".note-image-input").removeAttr("multiple");
        image_dialog.find(".note-group-image-url").hide();
        image_dialog.find(".note-image-url").attr("placeholder", "이미지 URL을 입력해주세요.");
        image_dialog.find(".note-image-btn").val("적용");
      }
    },
    setEditerText: function(text) {
      if (this.is_editor_load) {
        $("#summernote").summernote("code", text);
      }
    },
    resetEmailDetailSetting() {
      this.email_title = "";
      this.email_sender = null;
      this.email_content = this.getInitContentText(this.msg_type).replace(/\n/g, "<br/>");
      this.add_text_list = this.getUserTagList(this.getIsOrderMessage(this.msg_type), this.getAbleSerialTag(this.msg_type));
      this.getEmailDetailSetting();
      if (["buyed_confirm", "shipping_end"].includes(this.msg_type)) {
        this.getCheckTag(this.msg_type);
      }
    },
    saveSettings: function() {
      if (!this.inputValidate()) {
        return;
      }
      this.email_content = $("#summernote").summernote("code");

      const data = {
        msg_type: this.msg_type,
        email_title: this.email_title,
        email_content: this.email_content,
        //email_sender: "test@test.kr", // template email for debug
      };
      this.setDetailSetting(data);
    },
    setDetailSetting: async function(data) {
      try {
        const check_tag = "#{SERIAL_CODE}";
        if (this.isTagUsed(data.email_content, check_tag)) {
          if (await this.getUseTypeByTag(M, check_tag, this.msg_type)) {
            alert(
              "시리얼코드(미인증 코드 발송) 변수는 \n중복코드 발송 방지를 위해 배송완료 또는 구매확정 상태 발송시 1번만 발송이 가능합니다.\n해당 변수가 이미 추가된 상태이므로 삭제 후 설정해주세요.",
            );
            this.email_content = $("#summernote").summernote("code");
            this.email_content = this.email_content.replace(check_tag, "");
            this.setEditerText(this.email_content);

            return;
          }
        }
        const res = await M.api(M.entry("/put/message/detail/email"), data);
        if (res) {
          this.alertShow("저장되었습니다.");
        }
      } catch (err) {
        console.log("set email detail setting", err);
      }
    },
    getCheckTag: async function(chk_type) {
      const check_tag = "#{SERIAL_CODE}";
      try {
        const chk = await this.getUseTypeByTag(M, check_tag, chk_type);
        if (chk) {
          this.add_text_list = this.add_text_list.filter((tag) => tag.text !== check_tag);
        }
      } catch (err) {
        console.log("get check tag", err);
      }
    },
    closeModal: function() {
      this.$emit("close");
    },
    /*
    openEmailSenderModal() {
      this.$refs.EmailSetting.openEmailSettingModal();
    },*/
    getEmailDetailSetting: async function() {
      try {
        // call API
        const res = await M.api(M.entry("/get/message/detail/email"), { msg_type: this.msg_type });
        if (res) {
          if (res.email_content.length > 0) {
            this.email_content = res.email_content;
            this.email_title = res.email_title;
          }
        }
      } catch (err) {
        console.log("get Email Detail Setting", err);
      }
    },
    inputValidate: function() {
      if (!this.email_title) {
        this.alertShow("메일 제목을 입력해 주세요.");
        return false;
      }
      if (!this.email_content) {
        this.alertShow("메일 내용을 입력해 주세요.");
        return false;
      }
      return true;
    },
    addContentValue: function(text) {
      $("#summernote").summernote("insertText", text);
    },
    initContentText() {
      if (confirm("기본 제공하는 메시지 문구로 변경되어요.\n진행하시겠습니까?")) {
        this.email_content = this.getInitContentText(this.msg_type).replace(/\n/g, "<br/>");
        this.setEditerText(this.email_content);
      }
    },
  },
};
</script>
